import React, { useState } from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
// import axios from '../../../../store/sagas/axiosConfig';
import Button from '../../../Button';

const ItineraryDay = ({ destination, index, itineraryDays }) => {
  // const [cityDetails, setCityDetails] = useState(undefined);
  // const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const handleDetailsClick = () => {
    setShow((v) => !v);
  };
  // useEffect(() => {
  //   const getCityDetails = async () => {
  //     setLoading(true);
  //     const url = `/cruises/city/${destination.cityId}`;
  //     const config = {
  //       method: 'get',
  //       url,
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     };
  //     const details = await axios(config);
  //     setLoading(false);
  //     setCityDetails(details.data);
  //   };
  //   getCityDetails();
  // }, [destination.cityId]);
  return (
    <div
      key={destination.itineraryDayNumber + destination.cityName}
      className={clsx(
        'grid grid-cols-4 py-2 text-sm md:text-base gap-2',
        index < itineraryDays.length - 1 && 'border-b-2',
      )}
    >
      <div>
        <div className="font-bold">
          {`Day ${destination.itineraryDayNumber}`}
        </div>
        <div className="text-gray-600">
          {destination.itineraryDayDate
            && dayjs(destination.itineraryDayDate).format('ddd, MMM DD')}
        </div>
      </div>
      <div className="col-span-2">
        <div className="text-theme">{destination.cityName}</div>
        {/* {destination.portDescription && (
        <div className="text-xs capitalize">
          <MarkdownToHtml content={destination.portDescription.toLowerCase()} />
        </div>
        )} */}
        <div className="sm:grid grid-flow-col auto-cols-max gap-x-2">
          {destination.itineraryDayArrivalDateTime && (
            <div className="inline-block text-gray-600">
              {`Arrive: ${dayjs(destination.itineraryDayArrivalDateTime).format(
                'h:mm A',
              )}`}
            </div>
          )}
          {destination.itineraryDayArrivalDateTime
            && destination.itineraryDayDepartureDateTime && (
              <div className="border-l-2 justify-self-center" />
          )}
          {destination.itineraryDayDepartureDateTime && (
            <div className="inline-block text-gray-600">
              {`Depart: ${dayjs(
                destination.itineraryDayDepartureDateTime,
              ).format('h:mm A')}`}
            </div>
          )}
        </div>
      </div>
      <div className="text-right">
        <Button
          onClick={handleDetailsClick}
          type="button"
          variant={Button.buttonVariants.LINK}
          className="outline-none"
        >
          {!show && (
            <>
              <span>View details </span>
              <FaChevronDown className="inline-block" />
            </>
          )}
          {show && (
            <>
              <span>Hide details </span>
              <FaChevronUp className="inline-block" />
            </>
          )}
        </Button>
      </div>
      {show && (
        <div
          className="col-span-4 max-h-px transition-all duration-700 overflow-hidden mt-6"
          style={{ maxHeight: show ? '200vh' : 0 }}
        >
          {destination ? (
            <div className="grid grid-cols-4">
              <div className="pr-4">
                {destination.cityImage ? (
                  <input
                    type="image"
                    img
                    src={destination.cityImage}
                    alt="city image"
                    className="w-full"
                  />
                ) : <></>}
              </div>
              <div className="col-span-3">
                {destination.portDescription && (
                <div>
                  <h1 className="text-lg font-bold">Description</h1>
                  <p
                    dangerouslySetInnerHTML={{ __html: destination.portDescription.toLowerCase() }}
                  />
                </div>
                )}
                {destination.cityCurrency && (
                  <div>
                    <h1 className="text-lg font-bold mt-2">Currency</h1>
                    <p dangerouslySetInnerHTML={{ __html: destination.cityCurrency }} />
                  </div>
                )}
                {destination.cityAdventures && (
                  <div>
                    <h1 className="text-lg font-bold mt-2">Adventures</h1>
                    <p dangerouslySetInnerHTML={{ __html: destination.cityAdventures }} />
                  </div>
                )}
                {destination.cityActivities && (
                  <div>
                    <h1 className="text-lg font-bold mt-2">Activities</h1>
                    <p dangerouslySetInnerHTML={{ __html: destination.cityActivities }} />
                  </div>
                )}
                {destination.cityAttractions && (
                  <div>
                    <h1 className="text-lg font-bold mt-2">Attractions</h1>
                    <p dangerouslySetInnerHTML={{ __html: destination.cityAttractions }} />
                  </div>
                )}
                {destination.cityShopping && (
                  <div>
                    <h1 className="text-lg font-bold mt-2">Shopping</h1>
                    <p dangerouslySetInnerHTML={{ __html: destination.cityShopping }} />
                  </div>
                )}
                {destination.cityFood && (
                  <div>
                    <h1 className="text-lg font-bold mt-2">Food</h1>
                    <p dangerouslySetInnerHTML={{ __html: destination.cityFood }} />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div>
              {' '}
              Could not find any details!
              {' '}
            </div>
          )}

          {/* {cityDetails ? (
            <div className="grid grid-cols-4">
              {cityDetails.cityImage && (
                <div className="pr-4">
                  <input type="image" img src={cityDetails.cityImage}
                  alt="city image" className="w-full" />
                </div>
              )}
              <div className={clsx({ 'col-span-3': !!cityDetails.cityImage,
               'col-span-4': !cityDetails.cityImage })}>
                <div>
                  <h1 className="text-xl font-bold">{cityDetails.cityName}</h1>
                </div>
                <div>
                  <h1 className="text-lg font-bold">Description</h1>
                  <p dangerouslySetInnerHTML={{ __html: cityDetails.cityDescription }} />
                </div>
                {cityDetails.cityCurrency && (
                  <div>
                    <h1 className="text-lg font-bold mt-2">Currency</h1>
                    <p dangerouslySetInnerHTML={{ __html: cityDetails.cityCurrency }} />
                  </div>
                )}
                {cityDetails.cityAdventures && (
                  <div>
                    <h1 className="text-lg font-bold mt-2">Adventures</h1>
                    <p dangerouslySetInnerHTML={{ __html: cityDetails.cityAdventures }} />
                  </div>
                )}
                {cityDetails.cityActivities && (
                  <div>
                    <h1 className="text-lg font-bold mt-2">Activities</h1>
                    <p dangerouslySetInnerHTML={{ __html: cityDetails.cityActivities }} />
                  </div>
                )}
                {cityDetails.cityAttractions && (
                  <div>
                    <h1 className="text-lg font-bold mt-2">Attractions</h1>
                    <p dangerouslySetInnerHTML={{ __html: cityDetails.cityAttractions }} />
                  </div>
                )}
                {cityDetails.cityShopping && (
                  <div>
                    <h1 className="text-lg font-bold mt-2">Shopping</h1>
                    <p dangerouslySetInnerHTML={{ __html: cityDetails.cityShopping }} />
                  </div>
                )}
                {cityDetails.cityFood && (
                  <div>
                    <h1 className="text-lg font-bold mt-2">Food</h1>
                    <p dangerouslySetInnerHTML={{ __html: cityDetails.cityFood }} />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div>
              {' '}
              {loading ? 'Please wait...' : 'Could not find city details!'}
              {' '}
            </div>
          )} */}
        </div>
      )}
    </div>
  );
};

ItineraryDay.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  destination: PropTypes.object,
  index: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  itineraryDays: PropTypes.array,
};

ItineraryDay.defaultProps = {
  destination: undefined,
  index: undefined,
  itineraryDays: undefined,
};

export default ItineraryDay;
